export const accessControlsConstants = {
  CREATE_NEW_ACCESS_CONTROL_REQUEST: "CREATE_NEW_ACCESS_CONTROL_REQUEST",
  CREATE_NEW_ACCESS_CONTROL_SUCCESS: "CREATE_NEW_ACCESS_CONTROL_SUCCESS",
  CREATE_NEW_ACCESS_CONTROL_FAILURE: "CREATE_NEW_ACCESS_CONTROL_FAILURE",

  GETALL_ACCESS_CONTROLS_REQUEST: "ACCESS_CONTROLS_GETALL_REQUEST",
  GETALL_ACCESS_CONTROLS_SUCCESS: "ACCESS_CONTROLS_GETALL_SUCCESS",
  GETALL_ACCESS_CONTROLS_FAILURE: "ACCESS_CONTROLS_GETALL_FAILURE",

  GET_ACCESS_CONTROL_RESULT_REQUEST: "ACCESS_CONTROL_RESULT_REQUEST",
  GET_ACCESS_CONTROL_RESULT_SUCCESS: "ACCESS_CONTROL_RESULT_SUCCESS",
  GET_ACCESS_CONTROL_RESULT_FAILURE: "ACCESS_CONTROL_RESULT_FAILURE",

  GET_ACCESS_CONTROL_DETAILS_REQUEST: "ACCESS_CONTROL_DETAILS_REQUEST",
  GET_ACCESS_CONTROL_DETAILS_SUCCESS: "ACCESS_CONTROL_DETAILS_SUCCESS",
  GET_ACCESS_CONTROL_DETAILS_FAILURE: "ACCESS_CONTROL_DETAILS_FAILURE",

  GET_ACCESS_CONTROL_POLICIES_REQUEST: "ACCESS_CONTROL_POLICIES_REQUEST",
  GET_ACCESS_CONTROL_POLICIES_SUCCESS: "ACCESS_CONTROL_POLICIES_SUCCESS",
  GET_ACCESS_CONTROL_POLICIES_FAILURE: "ACCESS_CONTROL_POLICIES_FAILURE",

  GET_ACCESS_CONTROL_TOP_CARD_INFO_REQUEST:
    "GET_ACCESS_CONTROL_TOP_CARD_INFO_REQUEST",
  GET_ACCESS_CONTROL_TOP_CARD_INFO_SUCCESS:
    "GET_ACCESS_CONTROL_TOP_CARD_INFO_SUCCESS",
  GET_ACCESS_CONTROL_TOP_CARD_INFO_FAILURE:
    "GET_ACCESS_CONTROL_TOP_CARD_INFO_FAILURE",

  GET_ACCESS_CONTROL_FILTER_REQUEST: "ACCESS_CONTROL_FILTER_FETCH_REQUEST",
  GET_ACCESS_CONTROL_FILTER_SUCCESS: "ACCESS_CONTROL_FILTER_FETCH_SUCCESS",
  GET_ACCESS_CONTROL_FILTER_FAILURE: "ACCESS_CONTROL_FILTER_FETCH_FAILURE",

  ACCESS_CONTROLS_ROLE_ACTIVATE_REQUEST:
    "ACCESS_CONTROLS_ROLE_ACTIVATE_REQUEST",
  ACCESS_CONTROLS_ROLE_ACTIVATE_SUCCESS:
    "ACCESS_CONTROLS_ROLE_ACTIVATE_SUCCESS",
  ACCESS_CONTROLS_ROLE_ACTIVATE_FAILURE:
    "ACCESS_CONTROLS_ROLE_ACTIVATE_FAILURE",

  ACCESS_CONTROL_POLICIES_UPDATE_REQUEST:
    "ACCESS_CONTROL_POLICIES_UPDATE_REQUEST",
  ACCESS_CONTROL_POLICIES_UPDATE_SUCCESS:
    "ACCESS_CONTROL_POLICIES_UPDATE_SUCCESS",
  ACCESS_CONTROL_POLICIES_UPDATE_FAILURE:
    "ACCESS_CONTROL_POLICIES_UPDATE_FAILURE",

  UPDATE_ACCESS_CONTROLS_REQUEST:
    "UPDATE_ACCESS_CONTROLS_REQUEST",
  UPDATE_ACCESS_CONTROLS_SUCCESS:
    "UPDATE_ACCESS_CONTROLS_SUCCESS",
  UPDATE_ACCESS_CONTROLS_FAILURE:
    "UPDATE_ACCESS_CONTROLS_FAILURE",

  DELETE_ROLE_REQUEST: "DELETE_ROLE_REQUEST",
  DELETE_ROLE_SUCCESS: "DELETE_ROLE_SUCCESS",
  DELETE_ROLE_FAILURE: "DELETE_ROLE_FAILURE",

  FETCH_ALL_UI_NAVIGATION_REQUEST: "FETCH_ALL_UI_NAVIGATION_REQUEST",
  FETCH_ALL_UI_NAVIGATION_SUCCESS: "FETCH_ALL_UI_NAVIGATION_SUCCESS",
  FETCH_ALL_UI_NAVIGATION_FAILURE: "FETCH_ALL_UI_NAVIGATION_FAILURE",

  UPDATE_UI_NAVIGATION_REQUEST: "UPDATE_UI_NAVIGATION_REQUEST",
  UPDATE_UI_NAVIGATION_SUCCESS: "UPDATE_UI_NAVIGATION_SUCCESS",
  UPDATE_UI_NAVIGATION_FAILURE: "UPDATE_UI_NAVIGATION_FAILURE",

  UNASSIGN_UI_NAVIGATION_REQUEST: "UNASSIGN_UI_NAVIGATION_REQUEST",
  UNASSIGN_UI_NAVIGATION_SUCCESS: "UNASSIGN_UI_NAVIGATION_SUCCESS",
  UNASSIGN_UI_NAVIGATION_FAILURE: "UNASSIGN_UI_NAVIGATION_FAILURE",

  FETCH_UI_NAVIGATION_REQUEST: "FETCH_UI_NAVIGATION_REQUEST",
  FETCH_UI_NAVIGATION_SUCCESS: "FETCH_UI_NAVIGATION_SUCCESS",
  FETCH_UI_NAVIGATION_FAILURE: "FETCH_UI_NAVIGATION_FAILURE",

  FETCH_POLICIES_LIST_REQUEST:"FETCH_POLICIES_LIST_REQUEST",
  FETCH_POLICIES_LIST_SUCCESS:"FETCH_POLICIES_LIST_SUCCESS",
  FETCH_POLICIES_LIST_FAILURE:"FETCH_POLICIES_LIST_FAILURE",
  
  GETALL_ACTIVE_ROLES_REQUEST: "GETALL_ACTIVE_ROLES_REQUEST",
  GETALL_ACTIVE_ROLES_SUCCESS: "GETALL_ACTIVE_ROLES_SUCCESS",
  GETALL_ACTIVE_ROLES_FAILURE: "GETALL_ACTIVE_ROLES_FAILURE",
};
